module.exports = __webpack_public_path__ + "static/img/bg_light.9da41c8.png";